import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/apiClient";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiError(err));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-sm" data-testid="forgot-page">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs text-[#A3A3A3] hover:text-white uppercase tracking-widest font-bold mb-4" data-testid="forgot-back">
          <ArrowLeft className="w-3 h-3" /> Voltar ao login
        </Link>
        {submitted ? (
          <div className="kw-card p-8 text-center kw-fade-up" data-testid="forgot-sent">
            <CheckCircle2 className="w-10 h-10 text-[#00FF88] mx-auto mb-3" />
            <h1 className="font-display text-2xl font-black uppercase mb-2">Verifica o teu email</h1>
            <p className="text-sm text-[#A3A3A3]">
              Se a conta <strong className="text-white">{email}</strong> existir, vais receber um link para repor a palavra-passe. O link expira em <strong>1 hora</strong>.
            </p>
            <Link to="/login" className="kw-btn-secondary inline-block mt-5" data-testid="forgot-to-login">Voltar ao login</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="kw-card p-8 kw-fade-up" data-testid="forgot-form">
            <div className="flex items-center gap-2 mb-4">
              <Mail className="w-5 h-5 text-[#E50000]" />
              <div className="kw-overline">Recuperar acesso</div>
            </div>
            <h1 className="font-display text-3xl font-black uppercase mb-2">Esqueci-me da palavra-passe</h1>
            <p className="text-sm text-[#A3A3A3] mb-5">Indica o teu email e enviamos-te um link para criares uma nova.</p>
            <label className="kw-overline block mb-2">Email</label>
            <input type="email" required autoFocus className="kw-input mb-4" value={email}
              placeholder="o.teu@email.com"
              onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            <button type="submit" disabled={loading} className="kw-btn-primary w-full" data-testid="forgot-submit">
              {loading ? "A enviar…" : "Enviar link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
